import Axios from "axios";

const token = `Bearer ${localStorage.getItem("token")}`;
export const axios = Axios.create({
  baseURL: `${process.env.REACT_APP_WEB_API}`,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    baseUrl: window.location.href,
    token: token,
    language: localStorage.getItem("locale")
      ? localStorage.getItem("locale")
      : "vi",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "*",
      "Access-Control-Allow-Headers": "*",
    // Authorization: token
  },
});
